var _circle, _g, _circle2, _text, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmsError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_4382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.606 12.4518C10.7804 12.4518 10.9267 12.3927 11.0449 12.2745C11.1627 12.1567 11.2216 12.0106 11.2216 11.8362C11.2216 11.6618 11.1627 11.5155 11.0449 11.3974C10.9267 11.2796 10.7804 11.2207 10.606 11.2207C10.4316 11.2207 10.2853 11.2796 10.1672 11.3974C10.0494 11.5155 9.99049 11.6618 9.99049 11.8362C9.99049 12.0106 10.0494 12.1567 10.1672 12.2745C10.2853 12.3927 10.4316 12.4518 10.606 12.4518ZM13.0681 12.4518C13.2425 12.4518 13.3888 12.3927 13.507 12.2745C13.6248 12.1567 13.6837 12.0106 13.6837 11.8362C13.6837 11.6618 13.6248 11.5155 13.507 11.3974C13.3888 11.2796 13.2425 11.2207 13.0681 11.2207C12.8937 11.2207 12.7477 11.2796 12.6299 11.3974C12.5117 11.5155 12.4526 11.6618 12.4526 11.8362C12.4526 12.0106 12.5117 12.1567 12.6299 12.2745C12.7477 12.3927 12.8937 12.4518 13.0681 12.4518ZM15.5303 12.4518C15.7047 12.4518 15.8508 12.3927 15.9685 12.2745C16.0867 12.1567 16.1458 12.0106 16.1458 11.8362C16.1458 11.6618 16.0867 11.5155 15.9685 11.3974C15.8508 11.2796 15.7047 11.2207 15.5303 11.2207C15.3559 11.2207 15.2098 11.2796 15.092 11.3974C14.9738 11.5155 14.9147 11.6618 14.9147 11.8362C14.9147 12.0106 14.9738 12.1567 15.092 12.2745C15.2098 12.3927 15.3559 12.4518 15.5303 12.4518ZM6.91284 19.2226V8.14305C6.91284 7.80451 7.03349 7.51459 7.27477 7.2733C7.51565 7.03243 7.80536 6.91199 8.1439 6.91199H17.9924C18.3309 6.91199 18.6208 7.03243 18.8621 7.2733C19.103 7.51459 19.2234 7.80451 19.2234 8.14305V15.5294C19.2234 15.868 19.103 16.1579 18.8621 16.3992C18.6208 16.64 18.3309 16.7605 17.9924 16.7605H9.37496L6.91284 19.2226ZM8.1439 16.2527L8.86715 15.5294H17.9924V8.14305H8.1439V16.2527ZM8.1439 8.14305V16.2527V8.14305Z",
    fill: "#FFFFFF"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 7,
    r: 5,
    fill: "#FF0000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 17,
    y: 9,
    fill: "#FFFFFF",
    fontSize: 6,
    fontWeight: "bold"
  }, "!")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_4382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6364,
    height: 14.7727,
    fill: "white",
    transform: "translate(5.68188 5.68176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmsError);
export default __webpack_public_path__ + "static/media/iconSMSError.ca1b2d3e85bfa93ff05ab1cd42da17fd.svg";
export { ForwardRef as ReactComponent };